export const currentRouterName = (location) => {
  if (window.innerWidth > 475) {
    if (location.pathname.includes("/conversas")) return "Conversas"
    else if (location.pathname.includes("/dashboard")) return "Dashboard"
    else if (location.pathname.includes("/schedules")) return "Mensagens agendadas"
    else if (location.pathname.includes("/contacts")) return "Contatos"
    else if (location.pathname.includes("/chats")) return "Chat interno"
    else if (location.pathname.includes("/kanban")) return "Kanban"
    else if (location.pathname.includes("/fluxo")) return "Fluxo de conversas"
    else if (location.pathname.includes("/situacoes")) return "Situações"
    else if (location.pathname.includes("/quick-messages")) return "Respostas rápidas"
    else if (location.pathname.includes("/campaigns")) return "Campanhas"
    else if (location.pathname.includes("/contact-lists")) return "Lista de contatos"
    else if (location.pathname.includes("/campaigns-config")) return "Configurações"
    else if (location.pathname.includes("/announcements")) return "Informativos"
    else if (location.pathname.includes("/prompts")) return "Open.Ai"
    else if (location.pathname.includes("/queue-integration")) return "Integrações"
    else if (location.pathname.includes("/connections")) return "Conexões"
    else if (location.pathname.includes("/files")) return "Lista de arquivos"
    else if (location.pathname.includes("/queues")) return "Filas"
    else if (location.pathname.includes("/users")) return "Usuários"
    else if (location.pathname.includes("/portal-cliente")) return "Portal do Cliente"
    else if (location.pathname.includes("/messages-api")) return "API"
    else if (location.pathname.includes("/settings")) return "Configurações"
    else {
      location.pathname = "/conversas"
      return "Conversas"
    }
  }
}
